import { render, staticRenderFns } from "./AppLogs.vue?vue&type=template&id=a9aafdf8&scoped=true"
import script from "./AppLogs.vue?vue&type=script&lang=js"
export * from "./AppLogs.vue?vue&type=script&lang=js"
import style0 from "./AppLogs.vue?vue&type=style&index=0&id=a9aafdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aafdf8",
  null
  
)

export default component.exports